<template>
    <div class="HandPoseDetection" :class="{ disable : disable }">  
      <video class="HandPoseDetection__video" id="video" playsinline style="
            -webkit-transform: scaleX(-1);
            transform: scaleX(-1);
            visibility: auto;
            width: auto;
            height: auto;
            position: absolute;">
        </video>
      <div class="HandPoseDetection__hand ">{{ fdl }}</div>
      <div class="HandPoseDetection__hand right">{{ rgt_locked }}</div>  
    </div>
</template>

<script>

import gsap from "gsap"
import * as handPoseDetection from '@tensorflow-models/hand-pose-detection'
import '@tensorflow/tfjs-core'
import '@tensorflow/tfjs-backend-webgl'

import * as mpHands from '@mediapipe/hands'
import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm'

tfjsWasm.setWasmPaths(
    `https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`)

// import '@mediapipe/hands'
// import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm'

export default {

  name: 'HandPoseDetection',
  render: h => h(), 
  data: ()=>({

    fdl: 0,
    fdr: 0,
    plx: 0,
    prx: 0,
    nwl: 0,
    nwr: 0,
    lft_locked : false,
    rgt_locked: false,
    disable: false

  }),
  beforeDestroy() {
    if(this.rafID)
      cancelAnimationFrame(this.rafID)
    // this.removeHandPose()
  },
  mounted() {
    console.log('HandPoseDetection');
    this.init()
  },

  methods: {


    setupCamera: async function() {
      
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error(
            'Browser API navigator.mediaDevices.getUserMedia not available')
      }

      const video = document.getElementById('video')
      const stream = await navigator.mediaDevices.getUserMedia({
        'audio': false,
        'video': {
          facingMode: 'user',
          // Only setting the video to a specified size in order to accommodate a
          // point cloud, so on mobile devices accept the default size.
          width: 320,
          height: 240
        },
      })

      video.srcObject = stream

      return new Promise((resolve) => {
        video.onloadedmetadata = () => { resolve(video) }
      })
    },

    loadVideo: async function() {
      const video = await this.setupCamera()
      video.play()
      return video
    },

    createDetector: async function(model) {
      return handPoseDetection.createDetector(model, {
        runtime: 'mediapipe', // or 'tfjs'
        modelType: 'full',
        maxHands: 2,
        solutionPath: `https://cdn.jsdelivr.net/npm/@mediapipe/hands@${mpHands.VERSION}`
      })
    },

    init: async function() {
      
      let video
      const model = handPoseDetection.SupportedModels.MediaPipeHands

      try {

        video = await this.loadVideo()
        this.$detector = await this.createDetector(model)
        this.onLoop()

      } catch (e) {
   
        //  console.log('catch '+ e);
        throw e
      }

    },


    onLoop: async function() {

      let hands = await this.$detector.estimateHands( document.querySelector("video"), { flipHorizontal: false })

      console.log(hands);

      let res = ''

      if(hands[0])
        res = Math.round(hands[0]['keypoints'][0].x)

      this.fdl = res
      this.rafID = requestAnimationFrame(this.onLoop)   
      
    },

   
    // motionLeft() {
    //   if(this.lft_locked == true)
    //     return
    //   this.lft_locked = true
    //   this.$store.commit('app/MOTION_LEFT')
    //   gsap.delayedCall(.5, ()=>{ this.lft_locked = false })
    // },
    

  }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.HandPoseDetection
  position absolute 
  top 0 
  left 0
  width 100vw

  &__hand 
    position absolute
    border 1px solid red
    padding 4px 16px
    width 300px
    background red
    text-align center
    height 27px

    &.right 
      right 0

  &__video 
    top 50px
    right 13px

   
</style>















